import ModalConstants from 'app/shared/constants/ModalConstants';

import PaidInclusionPaymentModal from 'app/shared/containers/paidInclusion/PaymentModal';
import PaidInclusionValuePropModal from 'app/shared/components/paidInclusion/ValuePropModal';
import PaidInclusionDeactivationModal from 'app/shared/components/paidInclusion/DeactivationModal';

import AddPropertyModal from './AddPropertyModal';
import ArchivePropertyModal from './ArchivePropertyModal';
import AboutAddressEditsModal from './AboutAddressEditsModal';
import BillingAddPaymentModal from './BillingAddPaymentModal';
import BlockedUserModal from './BlockedUserModal';
import BoostAdPreviewsModal from './BoostAdPreviewsModal';
import ConfirmationModal from './ConfirmationModal';
import ConsolidatedPropertyListModal from './ConsolidatedPropertyListModal';
import EditUnitModal from './EditUnitModal';
import EditPropertyTypeModal from './EditPropertyTypeModal';
import EnableApplicationsModal from './EnableApplicationsModal';
import ErrorModal from './ErrorModal';
import FeedListingDeactivateConfirmationModal from './FeedListingDeactivateConfirmationModal';
import FeedListingDeactivateConfirmationThanksModal from './FeedListingDeactivateConfirmationThanksModal';
import FeedListingDeactivateConfirmationHasErrorModal from './FeedListingDeactivateConfirmationHasErrorModal';
import FeedListingDeactivateModal from './FeedListingDeactivateModal';
import InviteToApplyModal from './InviteToApplyModal';
import NotificationPromptModal from './NotificationPromptModal';
import PreActivationModal from './PreActivationModal';
import PaymentInfoModal from './PaymentInfoModal';
import PostActivationModal from './PostActivationModal';
import PostDeactivationModal from './PostDeactivationModal';
import ResendCompanyInviteModal from './ResendCompanyInviteModal';
import SelectTourModal from './SelectTourModal';
import SpecialOffersModal from './SpecialOffersModal';
import UserManagementPropertyListModal from './UserManagementPropertyListModal';
import VerifyEmailFailureModal from './VerifyEmailFailureModal';
import VerifyEmailModal from './VerifyEmailModal';
import ViewTourModal from './ViewTourModal';

// TODO: refactor following modals to be ModalContainer compatible
// i.e. move named export to the default export map
// export components
export {
    AddPropertyModal,
};

const Modals = {
    [ModalConstants.ADD_SPECIAL_OFFER_MODAL]: SpecialOffersModal,
    [ModalConstants.ARCHIVE_PROPERTY_MODAL]: ArchivePropertyModal,
    [ModalConstants.ABOUT_ADDRESS_EDITS_MODAL]: AboutAddressEditsModal,
    [ModalConstants.BILLING_ADD_PAYMENT_MODAL]: BillingAddPaymentModal,
    [ModalConstants.BOOST_AD_PREVIEWS]: BoostAdPreviewsModal,
    [ModalConstants.CONFIRMATION_MODAL]: ConfirmationModal,
    [ModalConstants.CONSOLIDATED_PROPERTY_LIST_MODAL]: ConsolidatedPropertyListModal,
    [ModalConstants.EDIT_UNIT_MODAL]: EditUnitModal,
    [ModalConstants.EDIT_PROPERTY_TYPE_MODAL]: EditPropertyTypeModal,
    [ModalConstants.ENABLE_APPLICATIONS_MODAL]: EnableApplicationsModal,
    [ModalConstants.ERROR_MODAL]: ErrorModal,
    [ModalConstants.FEED_LISTING_DEACTIVATE_CONFIRMATION_MODAL]: FeedListingDeactivateConfirmationModal,
    [ModalConstants.FEED_LISTING_DEACTIVATE_CONFIRMATION_THANKS_MODAL]: FeedListingDeactivateConfirmationThanksModal,
    [ModalConstants.FEED_LISTING_DEACTIVATE_CONFIRMATION_HAS_ERROR_MODAL]:
        FeedListingDeactivateConfirmationHasErrorModal,
    [ModalConstants.FEED_LISTING_DEACTIVATE_MODAL]: FeedListingDeactivateModal,
    [ModalConstants.INVITE_TO_APPLY_MODAL]: InviteToApplyModal,
    [ModalConstants.NOTIFICATION_MODAL]: NotificationPromptModal,
    [ModalConstants.PRE_ACTIVATION_MODAL]: PreActivationModal,
    [ModalConstants.POST_ACTIVATION_MODAL]: PostActivationModal,
    [ModalConstants.POST_DEACTIVATION_MODAL]: PostDeactivationModal,
    [ModalConstants.BLOCKED_USER_MODAL]: BlockedUserModal,
    [ModalConstants.PAID_INCLUSION_VALUE_PROP_MODAL]: PaidInclusionValuePropModal,
    [ModalConstants.PAID_INCLUSION_PAYMENT_MODAL]: PaidInclusionPaymentModal,
    [ModalConstants.PAID_INCLUSION_DEACTIVATION_MODAL]: PaidInclusionDeactivationModal,
    [ModalConstants.PAYMENT_INFO_MODAL]: PaymentInfoModal,
    [ModalConstants.RESEND_COMPANY_INVITE_MODAL]: ResendCompanyInviteModal,
    [ModalConstants.SELECT_TOUR_MODAL]: SelectTourModal,
    [ModalConstants.USER_MANAGEMENT_PROPERTY_LIST_MODAL]: UserManagementPropertyListModal,
    [ModalConstants.VERIFY_EMAIL_FAILURE_MODAL]: VerifyEmailFailureModal,
    [ModalConstants.VERIFY_EMAIL_MODAL]: VerifyEmailModal,
    [ModalConstants.VIEW_TOUR_MODAL]: ViewTourModal,
};

export default Modals;
